/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_VestingTemplateForListDto } from '../models/PagedResultDto_VestingTemplateForListDto';
import type { Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto } from '../models/Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto';
import type { Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationDto } from '../models/Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationDto';
import type { Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationRequestDto } from '../models/Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationRequestDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForViewDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForViewDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateImportResponseDTO } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateImportResponseDTO';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateSampleFileBlobDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTemplateService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppVestingTemplateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/vesting-template/vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingTemplateId 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingTemplateVestingTemplate(
vestingTemplateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-template/vesting-template/{vestingTemplateId}',
            path: {
                'vestingTemplateId': vestingTemplateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingTemplateId 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppVestingTemplateVestingTemplate(
vestingTemplateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/vesting-template/vesting-template/{vestingTemplateId}',
            path: {
                'vestingTemplateId': vestingTemplateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingTemplateId 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForViewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingTemplateVestingTemplateForView(
vestingTemplateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForViewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-template/vesting-template-for-view/{vestingTemplateId}',
            path: {
                'vestingTemplateId': vestingTemplateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingTypeIds 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_VestingTemplateForListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingTemplateVestingTemplateList(
vestingTypeIds?: Array<string>,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_VestingTemplateForListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-template/vesting-template-list',
            query: {
                'VestingTypeIds': vestingTypeIds,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVestingTemplateVestingTemplateAllList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateForListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vesting-template/vesting-template-all-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateVestingCalculationTest(
requestBody?: Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationDto,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/vesting-calculation-test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateVestingCalculationPreview(
requestBody?: Wealthlane_AwardService_Dtos_Common_VestingTemplateCalculationRequestDto,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_VestingCalculationResultDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/vesting-calculation-preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateDownloadVestingTemplateSample(): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/download-vesting-template-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateImportResponseDTO OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateImportBulkVestingTemplateExcel(
formData?: {
File: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateImportResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/import-bulk-vesting-template-excel',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param instruction 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateValidateSpecificVestingType(
instruction?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/validate-specific-vesting-type',
            query: {
                'instruction': instruction,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateCopyVestingTemplate(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template/copy-vesting-template/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
